import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import VouchersService from '../../../Api/VouchersService';

const ViewVouchers = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const voucherId = new URLSearchParams(location.search).get('id');
    const voucherAPI = new VouchersService();
    const [voucher, setVoucher] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchVoucher = async () => {
            if (!voucherId) {
                navigate('/vouchers-list');
                return;
            }

            try {
                const response = await voucherAPI.GetById(voucherId);
                if (response.data && response.data.data) {
                    setVoucher(response.data.data);
                } else {
                    throw new Error('Voucher not found');
                }
            } catch (err) {
                setError('Failed to load voucher details. Please try again.');
                console.error('Error loading voucher:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchVoucher();
    }, [voucherId, navigate]);

    if (loading) {
        return (
            <div className="text-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger" role="alert">
                {error}
            </div>
        );
    }

    if (!voucher) {
        return null;
    }

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body">
                <h4 className="text-xl text-primary-light mb-24">Voucher Details</h4>
                <div className="mb-3">
                    <strong>Code:</strong> {voucher.code}
                </div>
                <div className="mb-3">
                    <strong>Voucher Type:</strong> {voucher.voucher_type}
                </div>
                <div className="mb-3">
                    <strong>Discount Value:</strong> {voucher.voucher_type === 'percentage' ? `${voucher.discount_value}%` : `₹${voucher.discount_value}`}
                </div>
                <div className="mb-3">
                    <strong>Product Type:</strong> {voucher.product_type}
                </div>
                <div className="mb-3">
                    <strong>Usage Limit:</strong> {voucher.usage_limit}
                </div>
                <div className="mb-3">
                    <strong>Valid Until:</strong> {new Date(voucher.valid_until).toLocaleDateString()}
                </div>
                <button
                    type="button"
                    className="btn btn-secondary mt-3"
                    onClick={() => navigate('/vouchers-list')}
                >
                    Back to List
                </button>
            </div>
        </div>
    );
};

export default ViewVouchers;
